import Api from '../api';

const resource = '/payment-provider';

export default {
  get(locale: string, country: number, currency: number, headers: any) {
    let config;
    if (country && currency) {
      config = {
        code: locale,
        country,
        currency,
      };
    } else {
      config = {
        code: locale,
      };
    }
    return Api.post(`${resource}`, config, headers);
  },
};
